<template>
  <div>
    <v-tooltip bottom v-if="!isReadOnlyUser">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="openMoveDialog(item)"
          data-cy="move"
        >
          content_paste_go
        </v-icon>
      </template>
      <span>{{ $t("operatingInstructions.move") }}</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="downloadItem(item)"
          data-cy="download"
        >
          picture_as_pdf
        </v-icon>
      </template>
      <span>{{ $t("operatingInstructions.download") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="canCreateHere">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="copyItem(item)"
          data-cy="copy"
        >
          content_copy
        </v-icon>
      </template>
      <span>{{ $t("operatingInstructions.copy") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="!isReadOnlyUser">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="openEditDialog()"
          data-cy="edit"
          >edit</v-icon
        >
      </template>
      <span>{{ $t("operatingInstructions.edit") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="canDeleteHere">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="openDeleteDialog(item)"
          data-cy="delete"
        >
          delete</v-icon
        >
      </template>
      <span>{{ $t("operatingInstructions.delete") }}</span>
    </v-tooltip>
    <deleteDialog
      @triggerDelete="deleteItem"
      :item="item"
      :deleteDialog="deleteDialog"
    />
    <editOperatingInstructionDialog
      :state="editDialog"
      :item="item"
      @saved="onEdited"
      @label-deleted="reloadDataFunc"
    />
    <moveDialog
      :item="item"
      :moveDialog="moveDialog"
      :loading="moving"
      :array="instructionCategories"
      @cancel="moveDialog.open = false"
      @reload="reloadDataFunc"
      @confirm="handleMoveConfirm"
    />
  </div>
</template>

<script>
import deleteDialog from "../../_utils/dataTableHelpers/actions/deleteDialog.vue";
import editOperatingInstructionDialog from "../../formSlotComponents/operatingInstruction/operationInstructionEdit.vue";
import moveDialog from "../../_utils/dataTableHelpers/actions/moveDialog.vue";
export default {
  props: ["item"],
  components: {
    deleteDialog,
    editOperatingInstructionDialog,
    moveDialog,
  },
  data: () => ({
    deleteDialog: {
      open: false,
      title: "operatingInstructions.delete",
      description: "",
    },
    moveDialog: {
      open: false,
      title: "operatingInstructions.move",
      description: "",
      targetId: null,
    },
    moving: false,
    editDialog: { open: false },
    instructionCategories: [],
  }),
  methods: {
    createFormPath(item) {
      if (item) {
        return (
          "Betriebsanweisungen/" +
          item.name +
          "_" +
          item.location +
          "." +
          item.filetype
        );
      }
    },
    async downloadItem(item) {
      //open url to download file
      window.open(await this.getDownloadItemLink(item), "_blank");
    },
    async getDownloadItemLink(item) {
      //download path
      const formPath = this.createFormPath(item);
      if (formPath) {
        return await this.$store.dispatch("getPresignedDownloadUrl", formPath);
      }
    },
    async copyItem(item) {
      await this.$store.dispatch(
        "copyOperatingInstruction",
        item._id || item.id
      );
      this.reloadDataFunc();
    },
    openDeleteDialog(item) {
      this.deleteDialog.open = true;
      this.deleteDialog.description = this.$t("instructions.deleteTitleLong", {
        title: item.name,
      });
    },
    openEditDialog() {
      this.editDialog.open = true;
    },
    onEdited() {
      this.editDialog.open = false;
      this.reloadDataFunc();
    },
    deleteItem(item) {
      this.$store.dispatch("deleteOperatingInstruction", item).then(() => {
        this.reloadDataFunc();
        this.deleteDialog.open = false;
      });
    },
    reloadDataFunc() {
      this.$emit("reloadData");
    },
    async openMoveDialog(item) {
      this.moveDialog.open = true;
      this.moveDialog.targetId = item.id;
      this.moveDialog.description = this.$t(
        "operatingInstructions.movingOperatingInstruction",
        { name: item.name }
      );

      const result = await this.$store.dispatch("getAllInstructionCategories");

      const allCategories = Array.isArray(result)
        ? result
        : result?.items || result?.data || [];

      const currentId = this.$route.params.instructionCategoryId;

      this.instructionCategories = allCategories.filter(
        (loc) => String(loc.id) !== String(currentId)
      );
    },
    async handleMoveConfirm(targetId) {
      try {
        this.moving = true;
        await this.$store.dispatch("moveOperatingInstruction", {
          id: this.item.id,
          instructionCategory: targetId,
        });
        this.moveDialog.open = false;
        this.reloadDataFunc();
      } finally {
        this.moving = false;
      }
    },
  },
};
</script>
